import { IonButton, IonCard, IonCardContent, IonCol, IonGrid, IonInput, IonItem, IonLabel, IonRow, IonSelect, IonSelectOption, IonTextarea } from '@ionic/react';
import React, { useEffect, useRef, useState } from 'react';
import { useAppContext } from '../AppProvider';

const AccountBio: React.FC = () => {
    const [raceEdit, setRaceEdit] = useState<boolean>(false);
    const [genderEdit, setGenderEdit] = useState<boolean>(false);
    const [DOBEdit, setDOBEdit] = useState<boolean>(false);
    const [heightEdit, setHeightEdit] = useState<boolean>(false);
    const [weightEdit, setWeightEdit] = useState<boolean>(false);
    const [hairEdit, setHairEdit] = useState<boolean>(false);
    const [otherDescEdit, setOtherDescEdit] = useState<boolean>(false);
    const [medicalEdit, setMedicalEdit] = useState<boolean>(false);
    const [medicationsEdit, setMedicationsEdit] = useState<boolean>(false);
    const [allergiesEdit, setAllergiesEdit] = useState<boolean>(false);

    const [memberGender, setMemberGender] = useState<string>('');
    const [memberDOB, setMemberDOB] = useState<string>('');
    const [DOBDay, setDOBDay] = useState<string>('');
    const [DOBMonth, setDOBMonth] = useState<string>('');
    const [DOBMonthDays, setDOBMonthDays] = useState<any>();
    const [DOBYear, setDOBYear] = useState<any>('');
    const [DOBYears, setDOBYears] = useState<any>();
    
    const DOBMonthInputRef = useRef<any>();
    const DOBDayInputRef = useRef<any>();
    const DOBYearInputRef = useRef<any>();
    const weightUnitsInputRef = useRef<any>();

    const { authorizedMember, updateMember, monthNames, nl2br } = useAppContext();

    useEffect(() => {
         // Format Gender
         let gender = `${authorizedMember.memberGender}`;
         if(gender == '') gender = 'Not Recorded';
         else if(gender == 'F') gender = 'Female';
         else if(gender == 'M') gender = 'Male';
         else if(gender == 'O') gender = 'Non-binary';
         else if(gender == 'U') gender = 'Not Recorded';
         setMemberGender(gender);
         
        // Format DOB
        const today = new Date();
        const thisYear = today.getFullYear();
        const dob: any = `${authorizedMember.memberDOB}`;
        let dobDate: any;
        let dobDateStr = '';
        if(dob == '0') dobDateStr = 'Invalid Date';
        else {
            dobDate = new Date(dob*1000);
            dobDateStr = dobDate.toString();
        }

        let   days = 31;
        if(dobDateStr === 'Invalid Date') {             
            setMemberDOB('Not Recorded');
            setDOBDay('00');
            setDOBMonth('00');
            setDOBYear('0000');
        } else {
            const dobYear = dobDate.getFullYear();
            const dobMonth = dobDate.getMonth();
            const dobCalMonth = dobMonth < 9 ? `0${dobMonth + 1}` : `${dobMonth + 1}`
            const dobMonthName = monthNames[dobMonth];
            const dobDay = dobDate.getDate();
            days = new Date(dobYear, dobMonth, 0).getDate();
            // Get age
            const yearsDiff = thisYear - dobYear;
            const monthsDiff = today.getMonth() - dobMonth;
            const daysDiff = today.getDate() - dobDay;
            let age = (monthsDiff < 0 || (monthsDiff === 0 && daysDiff < 0)) ? yearsDiff - 1 : yearsDiff;       
            const dobStr = dobMonthName + ' ' + dobDay + ', ' + dobYear + ' (' + age + ' years)'; 
            setMemberDOB(dobStr);
            setDOBDay(dobDay.toString());
            setDOBMonth(dobCalMonth);
            setDOBYear(dobYear);            
        }     
        
        // Populate DOB Days options
        const daysOptions = [];
        for(let day = 1; day <= days; day++) daysOptions.push(day.toString());
        setDOBMonthDays(daysOptions);

        // Populate DOB Years options
        const start = thisYear - 18;
        const end = thisYear - 100;
        const yearsOptions = [];
        for(let y = start; y >= end; y--) yearsOptions.push(y);
        setDOBYears(yearsOptions);       

    }, [authorizedMember]);

    const getDaysByMonth = () => {	
        const yearSelect = DOBYearInputRef;
        const monthSelect = DOBMonthInputRef;
        const daySelect = DOBDayInputRef;
        const year = yearSelect.current.value;
        const month = monthSelect.current.value;
        const day = daySelect.current.value;
        const days = new Date(year, month, 0).getDate();
        const daysOptions = [];
        for(let d = 1; d <= days; d++) daysOptions.push(d);
        setDOBDay(day);
        setDOBMonth(month);
        setDOBMonthDays(daysOptions);
        setDOBYear(year);
    };
   
    const toggleRaceForm = () => setRaceEdit(!raceEdit);
    const toggleGenderForm = () => setGenderEdit(!genderEdit);
    const toggleDOBForm = () => setDOBEdit(!DOBEdit);
    const toggleHeightForm = () => setHeightEdit(!heightEdit);
    const toggleWeightForm = () => setWeightEdit(!weightEdit);
    const toggleHairForm = () => setHairEdit(!hairEdit);
    const toggleOtherDescForm = () => setOtherDescEdit(!otherDescEdit);
    const toggleMedicalForm = () => setMedicalEdit(!medicalEdit);
    const toggleMedicationsForm = () => setMedicationsEdit(!medicationsEdit);
    const toggleAllergiesForm = () => setAllergiesEdit(!allergiesEdit);

    return (
        <>
            <IonItem slot='header'>
                <IonLabel>My Bio / Medical Info</IonLabel>
            </IonItem>
            <div slot="content">                
                <IonCard>
                    <IonCardContent>
                        <IonLabel color={'dark'} onClick={toggleDOBForm}><b>Date of Birth</b></IonLabel>
                        { DOBEdit 
                            ? (<form name='DOBForm' onSubmit={updateMember}>
                                    <IonGrid>
                                        <IonRow>
                                            <IonCol size='6' sizeSm='4'>
                                                <IonSelect fill='outline' labelPlacement='stacked' name='memberDOBMonth' onIonChange={getDaysByMonth} placeholder='Month' ref={DOBMonthInputRef} value={DOBMonth}>                                     
                                                    <IonSelectOption value='00'>Month</IonSelectOption>
                                                    {monthNames.map((name:any, index:any) => (
                                                        <IonSelectOption key={index} value={index < 9 ? `0${index + 1}` : `${index + 1}`}>{name}</IonSelectOption>
                                                    ))}
                                                </IonSelect>
                                            </IonCol>
                                            <IonCol size='6' sizeSm='4'>
                                                <IonSelect fill='outline' labelPlacement='stacked' name='memberDOBDay' onIonChange={getDaysByMonth} placeholder='Day' ref={DOBDayInputRef} value={DOBDay}>                                     
                                                    <IonSelectOption value='00'>Day</IonSelectOption>
                                                    {DOBMonthDays.map((day:string, index:number) => (
                                                        <IonSelectOption key={index} value={index < 9 ? `0${index + 1}` : `${index + 1}`}>{day}</IonSelectOption>
                                                    ))}
                                                </IonSelect>
                                            </IonCol>
                                            <IonCol size='12' sizeSm='4'>
                                                <IonSelect fill='outline' labelPlacement='stacked' name='memberDOBYear' onIonChange={getDaysByMonth} placeholder='Year' ref={DOBYearInputRef} value={DOBYear}>                                     
                                                    <IonSelectOption value='0000'>Year</IonSelectOption>
                                                    {DOBYears.map((year:string, index:number) => (
                                                        <IonSelectOption key={index} value={year}>{year}</IonSelectOption>
                                                    ))}
                                                </IonSelect>
                                            </IonCol>
                                        </IonRow>
                                    </IonGrid>
                                    <IonButton className='ion-margin-top' color={'medium'} id='DOBFormCancel' onClick={toggleDOBForm}>Cancel</IonButton>
                                    <IonButton className='ion-margin-top' color={'secondary'} id='DOBFormSubmit' type='submit'>Save</IonButton>                                
                                </form>)                                                     
                            : (<p onClick={toggleDOBForm}>{memberDOB}</p>)
                        }
                    </IonCardContent>
                </IonCard>                
                             
                <IonCard>
                    <IonCardContent>
                        <IonLabel color={'dark'} onClick={toggleRaceForm}><b>Race or skin tone</b></IonLabel>
                        { raceEdit 
                            ? (<form name='raceForm' onSubmit={updateMember}>
                                    <IonInput className='ion-margin-top' fill='outline' name='memberRace' placeholder='Race or skin tone' type='text' value={authorizedMember.memberRace}></IonInput>
                                    <IonButton className='ion-margin-top' color={'medium'} id='raceFormCancel' onClick={toggleRaceForm}>Cancel</IonButton>
                                    <IonButton className='ion-margin-top' color={'secondary'} id='raceFormSubmit' type='submit'>Save</IonButton>
                                </form>)                                                     
                            : (<p onClick={toggleRaceForm}>{authorizedMember.memberRace == '' ? 'Not Recorded' : authorizedMember.memberRace}</p>)
                        }
                    </IonCardContent>
                </IonCard>                
                
                <IonCard>
                    <IonCardContent>
                        <IonLabel color={'dark'} onClick={toggleGenderForm}><b>Gender</b></IonLabel>
                        { genderEdit 
                            ? (<form name='genderForm' onSubmit={updateMember}>
                                    <IonSelect fill='outline' labelPlacement='stacked' name='memberGender' placeholder='Gender' value={authorizedMember.memberGender}>
                                        <IonSelectOption value='U'>I prefer not to say</IonSelectOption>
                                        <IonSelectOption value='F'>Female</IonSelectOption>
                                        <IonSelectOption value='M'>Male</IonSelectOption>
                                        <IonSelectOption value='O'>Non-binary</IonSelectOption>
                                    </IonSelect>
                                    <IonButton className='ion-margin-top' color={'medium'} id='genderFormCancel' onClick={toggleGenderForm}>Cancel</IonButton>
                                    <IonButton className='ion-margin-top' color={'secondary'} id='genderFormSubmit' type='submit'>Save</IonButton>
                                </form>)                                                     
                            : (<p onClick={toggleGenderForm}>{memberGender}</p>)
                        }
                    </IonCardContent>
                </IonCard>
                
                <IonCard>
                    <IonCardContent>
                        <IonLabel color={'dark'} onClick={toggleHeightForm}><b>Height</b></IonLabel>
                        { heightEdit 
                            ? (<form name='heightForm' onSubmit={updateMember}>
                                    <IonInput className='ion-margin-top' fill='outline' name='memberHeight' placeholder='Height' type='text' value={authorizedMember.memberHeight}></IonInput>
                                    <IonButton className='ion-margin-top' color={'medium'} id='heightFormCancel' onClick={toggleHeightForm}>Cancel</IonButton>
                                    <IonButton className='ion-margin-top' color={'secondary'} id='heightFormSubmit' type='submit'>Save</IonButton>
                                </form>)                                                     
                            : (<p onClick={toggleHeightForm}>{authorizedMember.memberHeight == '' ? 'Not Recorded' : authorizedMember.memberHeight}</p>)
                        }
                    </IonCardContent>
                </IonCard>                
                
                <IonCard>
                    <IonCardContent>
                        <IonLabel color={'dark'} onClick={toggleWeightForm}><b>Weight</b></IonLabel>
                        { weightEdit 
                            ? (<form name='weightForm' onSubmit={updateMember}>
                                    <IonGrid>
                                        <IonRow>
                                            <IonCol size='6'>
                                                <IonInput fill='outline' name='memberWeight' placeholder='Weight' type='number' value={authorizedMember.memberWeight}></IonInput>
                                            </IonCol>
                                            <IonCol size='6'>
                                                <IonSelect fill='outline' labelPlacement='stacked' name='memberWeightUnits' placeholder='Units' ref={weightUnitsInputRef} value={authorizedMember.memberWeightUnits}>  
                                                    <IonSelectOption value='LB'>LB</IonSelectOption>
                                                    <IonSelectOption value='KG'>KG</IonSelectOption>
                                                </IonSelect>
                                            </IonCol>                                   
                                        </IonRow>
                                    </IonGrid>
                                    <IonButton className='ion-margin-top' color={'medium'} id='weightFormCancel' onClick={toggleWeightForm}>Cancel</IonButton>
                                    <IonButton className='ion-margin-top' color={'secondary'} id='weightFormSubmit' type='submit'>Save</IonButton>
                                </form>)                                                     
                            : (<p onClick={toggleWeightForm}>{authorizedMember.memberWeight == '0' ? 'Not Recorded' : authorizedMember.memberWeight + ' ' + authorizedMember.memberWeightUnits}</p>)
                        }
                    </IonCardContent>
                </IonCard>                
                
                <IonCard>
                    <IonCardContent>
                        <IonLabel color={'dark'} onClick={toggleHairForm}><b>Hair Color & Style</b></IonLabel>
                        { hairEdit 
                            ? (<form name='hairForm' onSubmit={updateMember}>
                                    <IonInput className='ion-margin-top' fill='outline' name='memberHair' placeholder='Hair Color & Style' type='text' value={authorizedMember.memberHair}></IonInput>
                                    <IonButton className='ion-margin-top' color={'medium'} id='hairFormCancel' onClick={toggleHairForm}>Cancel</IonButton>
                                    <IonButton className='ion-margin-top' color={'secondary'} id='hairFormSubmit' type='submit'>Save</IonButton>
                                </form>)                                                     
                            : (<p onClick={toggleHairForm}>{authorizedMember.memberHair == '' ? 'Not Recorded' : authorizedMember.memberHair}</p>)
                        }
                    </IonCardContent>
                </IonCard>                
                
                <IonCard>
                    <IonCardContent>
                        <IonLabel color={'dark'} onClick={toggleOtherDescForm}><b>Other Descriptors</b></IonLabel>
                        { otherDescEdit 
                            ? (<form name='otherDescForm' onSubmit={updateMember}>
                                    <IonTextarea autoGrow={true} className='ion-margin-top' fill='outline' name='memberOtherDesc' placeholder='Eye color, eye glasses, tattoos, etc.' value={authorizedMember.memberOtherDesc}></IonTextarea>
                                    <IonButton className='ion-margin-top' color={'medium'} id='otherDescFormCancel' onClick={toggleOtherDescForm}>Cancel</IonButton>
                                    <IonButton className='ion-margin-top' color={'secondary'} id='otherDescFormSubmit' type='submit'>Save</IonButton>
                                </form>)                                                     
                            : (<p onClick={toggleOtherDescForm}>{authorizedMember.memberOtherDesc == '' ? 'Not Recorded' : (<span dangerouslySetInnerHTML={{ __html: nl2br(authorizedMember.memberOtherDesc) }} />)}</p>)
                        }
                    </IonCardContent>
                </IonCard>              
                
                <IonCard>
                    <IonCardContent>
                        <IonLabel color={'dark'} onClick={toggleMedicalForm}><b>Medical History & Provider</b></IonLabel>
                        { medicalEdit 
                            ? (<form name='medicalHistoryForm' onSubmit={updateMember}>
                                    <IonTextarea autocapitalize='sentences' autoGrow={true} className='ion-margin-top' fill='outline' name='memberMedicalHistory' placeholder='Medical History' value={authorizedMember.memberMedicalHistory}></IonTextarea>
                                    <IonButton className='ion-margin-top' color={'medium'} id='medicalHistoryFormCancel' onClick={toggleMedicalForm}>Cancel</IonButton>
                                    <IonButton className='ion-margin-top' color={'secondary'} id='medicalHistoryFormSubmit' type='submit'>Save</IonButton>
                                </form>)                                                     
                            : (<p onClick={toggleMedicalForm}>{authorizedMember.memberMedicalHistory == '' ? 'Not Recorded' : (<span dangerouslySetInnerHTML={{ __html: nl2br(authorizedMember.memberMedicalHistory) }} />)}</p>)
                        }
                    </IonCardContent>
                </IonCard>

                <IonCard>
                    <IonCardContent>
                        <IonLabel color={'dark'} onClick={toggleMedicationsForm}><b>Medications</b></IonLabel>
                        { medicationsEdit 
                            ? (<form name='medicationsForm' onSubmit={updateMember}>
                                    <IonTextarea autoGrow={true} className='ion-margin-top' fill='outline' name='memberMedications' placeholder='Medications' value={authorizedMember.memberMedications}></IonTextarea>
                                    <IonButton className='ion-margin-top' color={'medium'} id='medicationsFormCancel' onClick={toggleMedicationsForm}>Cancel</IonButton>
                                    <IonButton className='ion-margin-top' color={'secondary'} id='medicationsFormSubmit' type='submit'>Save</IonButton>
                                </form>)                                                     
                            : (<p onClick={toggleMedicationsForm}>{authorizedMember.memberMedications == '' ? 'Not Recorded' : (<span dangerouslySetInnerHTML={{ __html: nl2br(authorizedMember.memberMedications) }} />)}</p>)
                        }
                    </IonCardContent>
                </IonCard>               
                
                <IonCard>
                    <IonCardContent>
                        <IonLabel color={'dark'} onClick={toggleAllergiesForm}><b>Allergies</b></IonLabel>
                        { allergiesEdit 
                            ? (<form name='allergiesForm' onSubmit={updateMember}>
                                    <IonTextarea autoGrow={true} className='ion-margin-top' fill='outline' name='memberAllergies' placeholder='Allergies' value={authorizedMember.memberAllergies}></IonTextarea>
                                    <IonButton className='ion-margin-top' color={'medium'} id='allergiesFormCancel' onClick={toggleAllergiesForm}>Cancel</IonButton>
                                    <IonButton className='ion-margin-top' color={'secondary'} id='allergiesFormSubmit' type='submit'>Save</IonButton>
                                </form>)                                                     
                            : (<p onClick={toggleAllergiesForm}>{authorizedMember.memberAllergies == '' ? 'Not Recorded' : (<span dangerouslySetInnerHTML={{ __html: nl2br(authorizedMember.memberAllergies) }} />)}</p>)
                        } 
                    </IonCardContent>
                </IonCard>               
            </div>
        </>
    );
};

export default AccountBio;